import { complex as e } from "./atoms-v2943.js";
const n = (r, t) => t === "zIndex" ? !1 : !!(typeof r == "number" || Array.isArray(r) || typeof r == "string" && // It's animatable if we have a string
(e.test(r) || r === "0") && // And it contains numbers and/or colors
!r.startsWith("url("));
export {
  n as isAnimatable
};
